/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupManagementModel } from '../../models/group-management-model';
import { GroupManagementModelApiRespModel } from '../../models/group-management-model-api-resp-model';

export interface ApiManagementGroupEditPost$Params {
  id?: string;
      body?: GroupManagementModel
}

export function apiManagementGroupEditPost(http: HttpClient, rootUrl: string, params?: ApiManagementGroupEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupManagementModelApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiManagementGroupEditPost.PATH, 'post');
  if (params) {
    rb.query('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupManagementModelApiRespModel>;
    })
  );
}

apiManagementGroupEditPost.PATH = '/api/Management/Group/Edit';
